import { Routes, Route, Navigate } from 'react-router-dom'
import { useAuthStore } from './stores/authStore'
import Layout from './components/Layout'
import PatientLayout from './components/PatientLayout'
import Login from './pages/auth/Login'
import PasswordReset from './pages/auth/PasswordReset'
import Portal from './pages/Portal'
import PatientList from './pages/patients/PatientList'
import PatientDetail from './pages/patients/PatientDetail'
import PatientCreate from './pages/patients/PatientCreate'
import PatientEdit from './pages/patients/PatientEdit'
import ReservationCalendar from './pages/reservations/ReservationCalendar'
import ReservationCreate from './pages/reservations/ReservationCreate'
import ReservationDetail from './pages/reservations/ReservationDetail'
import MedicalRecordList from './pages/medical-records/MedicalRecordList'
import MedicalRecordDetail from './pages/medical-records/MedicalRecordDetail'
import MedicalRecordCreate from './pages/medical-records/MedicalRecordCreate'
import MedicalRecordEdit from './pages/medical-records/MedicalRecordEdit'
import AsdDiaryList from './pages/asd-diaries/AsdDiaryList'
import SeminarList from './pages/seminars/SeminarList'
import BoardSpace from './pages/boards/BoardSpace'
import PaperList from './pages/papers/PaperList'
import Reports from './pages/reports/Reports'
import UserProfile from './pages/users/UserProfile'
import HospitalList from './pages/master/HospitalList'
import HospitalDetail from './pages/master/HospitalDetail'
import HospitalEdit from './pages/master/HospitalEdit'
import DoctorList from './pages/master/DoctorList'
import DoctorDetail from './pages/master/DoctorDetail'
import DoctorEdit from './pages/master/DoctorEdit'
// 患者用ページ
import PatientDashboard from './pages/patient/PatientDashboard'
import DailyRecord from './pages/patient/DailyRecord'
import PatientRecords from './pages/patient/PatientRecords'
import Questionnaire from './pages/patient/Questionnaire'

// 医療従事者用の認証チェック
function PrivateRoute({ children }: { children: React.ReactNode }) {
  const { isAuthenticated, user } = useAuthStore()
  
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />
  }
  
  // 患者の場合は患者ポータルへリダイレクト
  if (user?.role === 'patient') {
    return <Navigate to="/patient" replace />
  }
  
  return <>{children}</>
}

// 患者用の認証チェック
function PatientRoute({ children }: { children: React.ReactNode }) {
  const { isAuthenticated, user } = useAuthStore()
  
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />
  }
  
  // 医療従事者の場合はメインポータルへリダイレクト
  if (user?.role !== 'patient') {
    return <Navigate to="/" replace />
  }
  
  return <>{children}</>
}

function App() {
  return (
    <Routes>
      {/* 認証ページ */}
      <Route path="/login" element={<Login />} />
      <Route path="/password-reset" element={<PasswordReset />} />
      
      {/* 医療従事者用ページ */}
      <Route
        path="/"
        element={
          <PrivateRoute>
            <Layout />
          </PrivateRoute>
        }
      >
        <Route index element={<Portal />} />
        
        {/* 患者カルテ */}
        <Route path="patients" element={<PatientList />} />
        <Route path="patients/create" element={<PatientCreate />} />
        <Route path="patients/:id" element={<PatientDetail />} />
        <Route path="patients/:id/edit" element={<PatientEdit />} />
        
        {/* 移植予約 */}
        <Route path="reservations" element={<ReservationCalendar />} />
        <Route path="reservations/create" element={<ReservationCreate />} />
        <Route path="reservations/:id" element={<ReservationDetail />} />
        
        {/* 診療記録 */}
        <Route path="medical-records" element={<MedicalRecordList />} />
        <Route path="medical-records/create" element={<MedicalRecordCreate />} />
        <Route path="medical-records/:id" element={<MedicalRecordDetail />} />
        <Route path="medical-records/:id/edit" element={<MedicalRecordEdit />} />
        
        {/* ASDダイアリー */}
        <Route path="asd-diaries" element={<AsdDiaryList />} />
        
        {/* 勉強会 */}
        <Route path="seminars" element={<SeminarList />} />
        
        {/* 掲示板 */}
        <Route path="boards/:spaceId" element={<BoardSpace />} />
        
        {/* 論文共有 */}
        <Route path="papers" element={<PaperList />} />
        
        {/* レポート */}
        <Route path="reports" element={<Reports />} />
        
        {/* マスター管理 */}
        <Route path="master/hospitals" element={<HospitalList />} />
        <Route path="master/hospitals/create" element={<HospitalEdit />} />
        <Route path="master/hospitals/:id" element={<HospitalDetail />} />
        <Route path="master/hospitals/:id/edit" element={<HospitalEdit />} />
        <Route path="master/doctors" element={<DoctorList />} />
        <Route path="master/doctors/create" element={<DoctorEdit />} />
        <Route path="master/doctors/:id" element={<DoctorDetail />} />
        <Route path="master/doctors/:id/edit" element={<DoctorEdit />} />
        
        {/* ユーザー */}
        <Route path="users/:id" element={<UserProfile />} />
      </Route>
      
      {/* 患者用ページ */}
      <Route
        path="/patient"
        element={
          <PatientRoute>
            <PatientLayout />
          </PatientRoute>
        }
      >
        <Route index element={<PatientDashboard />} />
        <Route path="daily-record" element={<DailyRecord />} />
        <Route path="records" element={<PatientRecords />} />
        <Route path="questionnaire" element={<Questionnaire />} />
      </Route>
    </Routes>
  )
}

export default App
